import "./administrative-law.dff6a4f3.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire48bd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire48bd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
// src/js/service-types-sidebar-script.js

var $aaQnt = parcelRequire("aaQnt");
(0, (/*@__PURE__*/$parcel$interopDefault($aaQnt)))(window).on('load', ()=>{
    const currentUrl = window.location.pathname.split('/').pop();
    const $links = (0, (/*@__PURE__*/$parcel$interopDefault($aaQnt)))('.service-buttons li a');
    const $currentLink = (0, (/*@__PURE__*/$parcel$interopDefault($aaQnt)))(`.service-buttons li a[href="/${currentUrl}"]`);
    if ($currentLink.length > 0) {
        Array.from($links).forEach((link)=>(0, (/*@__PURE__*/$parcel$interopDefault($aaQnt)))(link).parent().removeClass('select'));
        Array.from($currentLink).forEach((link)=>(0, (/*@__PURE__*/$parcel$interopDefault($aaQnt)))(link).parent().addClass('select'));
    }
});


//# sourceMappingURL=administrative-law.9cf5597e.js.map
